import 'react'
import { Avatar, Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface PillarItemProps {
    icon?: string,
    subtitle?: string,
    caption?: string,
}

const PillarItem = function (props: PillarItemProps) {
    const { icon, subtitle, caption } = props
    const { t } = useTranslation(`introduction`)

    return (
        <Grid item container xs={12} sm={5}>
            <Grid container justifyContent={`center`}>
                {
                    icon && subtitle && caption &&
                    <>
                        <Grid item mr={2}>
                            <Avatar src={icon} alt="pillar-icon" />
                        </Grid>
                        <Grid item xs={10}>
                            <Typography variant="h4" color="text.primary">{t(subtitle)}</Typography>
                            <Typography variant="body1">{t(caption)}</Typography>
                        </Grid>
                    </>
                }
            </Grid>
        </Grid>
    )
}

export default PillarItem